/**
 * Heading capitals (LP-11). Serif page and section headings take a capital
 * on each word ("Notes To Confirm", "From Your Team"); labels, chips,
 * status lines, buttons and body copy stay in sentence case ("My time",
 * "Add a task"). An all-capitals word (SPICE) is an acronym and passes
 * either rule. tests/ui/headingCase.test.ts holds every heading below and
 * every nav label to its rule.
 */

/** The serif headings on My Clients. */
export const MY_CLIENTS_HEADINGS = {
  page: 'My Clients',
  myWeek: 'My Week',
  comingUp: 'Coming Up',
  notesToConfirm: 'Notes To Confirm',
  myTasks: 'My Tasks',
  fromYourTeam: 'From Your Team',
} as const;

function words(text: string): string[] {
  return text.split(/\s+/).filter(Boolean);
}

function isAcronym(word: string): boolean {
  return word.length > 1 && word === word.toUpperCase() && /[A-Z]/.test(word);
}

/** Every word starts with a capital. */
export function isHeadingCase(text: string): boolean {
  return words(text).every((w) => /^[A-Z]/.test(w));
}

/** The first word starts with a capital; later words do not, unless they
 *  are acronyms. */
export function isSentenceCase(text: string): boolean {
  const [first, ...rest] = words(text);
  if (first === undefined || !/^[A-Z]/.test(first)) return false;
  return rest.every((w) => isAcronym(w) || !/^[A-Z]/.test(w));
}
